interface Props {
  label: string
  meta?: string
  action?: React.ReactNode
  children: React.ReactNode
}

/** Label + hairline used by run-page presenters. Not the shared `Section` primitive. */
export function PresenterSection({ label, meta, action, children }: Props) {
  return (
    <section>
      <div className="mb-3 flex items-baseline gap-3">
        <h3 className="m-0 text-xs font-semibold uppercase tracking-[0.08em] text-ink-3">
          {label}
        </h3>
        <div className="h-px flex-1 bg-line" />
        {meta ? <span className="text-11 text-ink-4 tabular-nums">{meta}</span> : null}
        {action}
      </div>
      {children}
    </section>
  )
}
